<template>
  <div class="sorttable">
    <!-- <div class="search">
      <div class="searchItem">
        <p class="searchLabel">代理商</p>
        <div class="searchInfo">
          <el-radio-group v-model="formes.audit_state" @change="getMainData">
            <el-radio-button :label="4">全部</el-radio-button>
            <el-radio-button :label="1">已审核</el-radio-button>
            <el-radio-button :label="0">未审核</el-radio-button>
            <el-radio-button :label="2">已拒绝</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="searchItem">
        <p class="searchLabel">发展人类型</p>
        <div class="searchInfo">
          <el-radio-group v-model="formes.develop_type" @change="getMainData">
            <el-radio-button :label="3">全部</el-radio-button>
            <el-radio-button :label="0">超管</el-radio-button>
            <el-radio-button :label="1">代理商</el-radio-button>
            <el-radio-button :label="2">二级代理商</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div> -->
    <div
      ref="caozuo"
      style="display: flex; justify-content: space-between; margin-bottom: 10px"
    >
      <div style="line-height: 40px">
        <el-button size="small" @click="dialogFormVisible">
          <i class="el-icon-plus"></i> 新增
        </el-button>
        <!-- <el-button size="small" @click="daoru">
          <i class="el-icon-plus"></i> 批量导入
        </el-button> -->
        <el-button size="small" @click="shuaxin">
          <i class="el-icon-refresh-right"></i> 刷新
        </el-button>
        <ExportExcel
          :E_ids="E_ids"
          :E_condition="E_condition"
          :E_dataLength="E_dataLength"
          :E_methodname="E_methodname"
          :E_searchArr="E_searchArr"
        ></ExportExcel>
      </div>

      <div>
        <el-form :model="formes" :inline="true" label-width="90px">
          <el-form-item label style="margin-bottom: 0">
            <el-select
              v-model="select"
              placeholder="请选择"
              size="small"
              class="especially"
              style="width: 110px"
              @change="switchover"
            >
              <el-option label="用户名" value="1"></el-option>
              <el-option label="手机号" value="2"></el-option>
              <el-option label="代理商ID" value="3"></el-option>
            </el-select>
            <!-- 关键字 -->
            <el-input
              @input="inputsearch"
              placeholder="关键字"
              size="small"
              v-model="formes.keywords"
              style="width: 160px"
              class="especially2"
            >
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-table
      :height="zhanshi"
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      ref="multipleTable"
    >
      <!-- @row-click="particulars" -->
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="id" label="代理商ID">
        <template slot-scope="scope">
          <span style="color: #67c23a">
            {{ scope.row.id ? scope.row.id : "xxx" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="用户名"></el-table-column>
      <el-table-column prop="mobile" label="手机号码"></el-table-column>
      <el-table-column prop="mobile" label="发展人">
        <template slot-scope="scope">
          <span v-if="scope.row.parentUserInfo.name">{{
            scope.row.parentUserInfo.name
          }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="label" label="标签"></el-table-column> -->
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0" style="color: #ff3b30"
            >禁止登录</span
          >
          <span v-else style="color: #359746">正常</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="money" label="余额"> </el-table-column> -->
      <el-table-column prop="created_at" label="创建时间" sortable width="160">
      </el-table-column>
      <el-table-column
        prop="last_login_time"
        label="最后登录时间"
        sortable
        width="160"
      >
      </el-table-column>
      <el-table-column prop="login_ip" label="登录IP"></el-table-column>
      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button-group>
            <el-link
              type="primary"
              @click="onrecharge(scope.row)"
              v-show="scope.row.is_direct_son == 1"
              >充值
            </el-link>
            <span class="activespan" v-show="scope.row.is_direct_son == 1"
              >|</span
            >
            <el-link
              type="primary"
              @click="Rechargekou(scope.row)"
              v-show="scope.row.is_direct_son == 1"
              >扣款
            </el-link>
            <span class="activespan" v-show="scope.row.is_direct_son == 1"
              >|</span
            >
            <el-link type="primary" @click="handleEdit(scope.row)"
              >编辑
            </el-link>
            <!-- <span class="activespan">|</span>
            <el-link type="primary" @click="getWebCname(scope.row)"
              >跳转
            </el-link> -->
            <!-- <span class="activespan">|</span> -->
            <!-- <el-link type="primary" @click="usersDaoru(scope.row)"
              >导入用户
            </el-link>
            <span class="activespan">|</span> -->
            <!-- <el-link type="primary" @click="onReset(scope.row)"
              >重置密码
            </el-link> -->
            <!-- <el-button
              size="mini"
              type="primary"
              plain
              :disabled="scope.row.status == 0"
              @click.native.stop="getWebCname(scope.row)"
              >跳转</el-button
            > -->
          </el-button-group>
          <!-- <div style="margin-top: 8px">
            <el-button-group>
              <el-button
                size="mini"
                type="primary"
                plain
                @click.native.stop="usersDaoru(scope.row)"
                >导入用户</el-button
              >
              <el-button
                size="mini"
                type="primary"
                plain
                @click.native.stop="onReset(scope.row)"
                >重置密码</el-button
              >

              <el-button
              size="mini"
              type="danger"
              plain
              @click.native.stop="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
            </el-button-group>
          </div> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      class="pagination_bottom"
      background
      layout="total,sizes, prev, pager, next"
      :page-sizes="[20, 50, 100, 200, 300, 400]"
      @size-change="handleSizeChange"
      :total="total"
      :page-size="pagesize"
      @current-change="current_change"
      :current-page="currentPage"
    ></el-pagination>

    <!-- 充值弹出框 -->
    <el-dialog
      title="充值"
      :visible.sync="dialogTableVisible"
      width="400px"
      @close="guanbi('loginFormRef2')"
    >
      <el-form :model="form2" ref="loginFormRef2" :rules="loginFormRules">
        <el-form-item label="充值对象:" :label-width="formLabelWidth">
          <div>{{ name }}</div>
        </el-form-item>
        <el-form-item
          label="充值类型:"
          :label-width="formLabelWidth"
          prop="style"
        >
          <el-select
            v-model="form2.style"
            style="width: 230px"
            placeholder="请选择"
          >
            <el-option
              v-if="this.pay_type == 0"
              label="余额"
              :value="1"
            ></el-option>
            <el-option
              v-if="this.pay_type == 1"
              label="授权"
              :value="2"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="this.form2.style == 2"
          label="产品类型:"
          :label-width="formLabelWidth"
          prop="package_type"
        >
          <el-select
            v-model="form2.package_type"
            style="width: 230px"
            placeholder="请选择"
            @change="setMeal"
          >
            <!-- <el-option-group label="通信产品">
              <el-option
                v-if="
                  this.package.black_num != undefined &&
                    this.package.black_num.length > 0
                "
                label="防骚扰"
                :value="1"
              ></el-option>
              <el-option
                v-if="
                  this.package.call_num != undefined &&
                    this.package.call_num.length > 0
                "
                label="语音"
                :value="2"
              ></el-option>
              <el-option
                v-if="
                  this.package.sms_num != undefined &&
                    this.package.sms_num.length > 0
                "
                label="文字短信"
                :value="3"
              ></el-option>
              <el-option
                v-if="
                  this.package.video_sms_num != undefined &&
                    this.package.video_sms_num.length > 0
                "
                label="视频短信"
                :value="4"
              ></el-option>
            </el-option-group>
            <el-option-group label="Saas产品">
              <el-option
                v-if="
                  this.package.crm_num != undefined &&
                  this.package.crm_num.length > 0
                "
                label="CRM"
                :value="5"
              ></el-option>
              <el-option
                v-if="
                  this.package.other_num != undefined &&
                    this.package.other_num.length > 0
                "
                label="呼叫中心"
                :value="7"
              ></el-option>
            </el-option-group> -->
            <el-option
              v-if="
                this.package.other_num != undefined &&
                  this.package.other_num.length > 0
              "
              label="呼叫中心"
              :value="7"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="this.form2.style == 2"
          label="套餐:"
          :label-width="formLabelWidth"
          prop="package_id"
        >
          <el-select
            v-model="form2.package_id"
            style="width: 230px"
            placeholder="请选择"
            @change="SysAction"
          >
            <el-option
              v-for="(item, index) in this.packageList"
              :key="index"
              :label="item.package_name + '(' + item.number + ')'"
              :value="item.package_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="this.form2.style == 1"
          label="余额："
          :label-width="formLabelWidth"
        >
          <div>{{ form2.money ? form2.money : 0 }}</div>
        </el-form-item>
        <el-form-item
          v-if="this.form2.style == 2"
          label="余数："
          :label-width="formLabelWidth"
        >
          <div>{{ this.count }}</div>
        </el-form-item>
        <el-form-item
          v-if="this.form2.style == 1"
          label="充值金额："
          :label-width="formLabelWidth"
          prop="charge"
          :rules="[{ required: true, validator: minRules, trigger: 'blur' }]"
        >
          <el-input
            style="width: 230px"
            v-model="form2.charge"
            autocomplete="off"
            onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="this.form2.style == 2"
          label="充值个数："
          :label-width="formLabelWidth"
          prop="charge"
          :rules="[{ required: true, validator: minRules2, trigger: 'blur' }]"
        >
          <el-input
            style="width: 230px"
            v-model="form2.charge"
            autocomplete="off"
            oninput="this.value = this.value.replace(/[^\d]/g,'')"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="备注：" :label-width="formLabelWidth">
          <el-input
            style="width: 230px"
            v-model="form2.remark"
            autocomplete="off"
          ></el-input>
        </el-form-item> -->
        <el-form-item
          style="width: 95%; display: flex; justify-content: flex-end"
        >
          <el-button size="small" @click="dialogTableVisible = false"
            >取 消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="addRecharge('loginFormRef2')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 充值弹出框 -->
    <!-- 扣款 -->
    <el-dialog
      title="扣款授权"
      :visible.sync="dialogTableVisiblekou"
      width="600px"
      class="dialogbox"
    >
      <el-form :rules="rules" ref="form" :model="form">
        <el-form-item label="授权商品:" label-width="180px">
          <el-select
            v-model="call_type_id"
            placeholder="请选择授权商品"
            size="small"
            style="width: 270px"
            @change="changeCalltype"
          >
            <el-option
              v-for="item in callTypeArr"
              :key="item.call_type_id"
              :label="item.callTypeInfo.card"
              :value="item.call_type_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="扣款对象:" label-width="180px">
          <span class="el-span">{{ scoperow.name }}</span>
        </el-form-item>
        <el-form-item label="代理商剩余授权数:" label-width="180px">
          <span class="el-span">{{
            userCallTypeArr.sum ? userCallTypeArr.sum - userCallTypeArr.use : 0
          }}</span>
        </el-form-item>
        <el-form-item label="扣款授权数:" label-width="180px" prop="num">
          <el-input
            v-model="form.num"
            style="width: 270px"
            placeholder="请输入"
            @input="changeKokuanNumber"
            onkeyup="value=value.replace(/[^\d]/g,'').replace(/^0{1,}/g,'')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisiblekou = false">取 消</el-button>
        <el-button type="primary" @click="addRechargekou('form')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 扣款 -->

    <router-view ref="Childmain"></router-view>
    <!-- 导入弹出层 -->
    <el-dialog
      title="导入"
      :visible.sync="dialogDaoruVisible"
      :destroy-on-close="true"
      width="500px"
    >
      <el-form :model="form3" ref="ruleForm2" label-width="80px">
        <el-form-item label="上传文件">
          <el-upload
            class="upload-demo"
            action="#"
            accept=".xlsx"
            :limit="1"
            :file-list="fileList"
            :on-change="changeFile"
            :on-remove="changeRemove"
            :auto-upload="false"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入模板">
          <span style="color: #26a7ff; cursor: pointer" @click="down"
            >点击下载模板</span
          >
        </el-form-item>
        <!-- <el-form-item label="并发">
          <el-input style="width: 50px" v-model="bingfa"></el-input>
        </el-form-item> -->
        <el-form-item label="说明">
          <span>每次导上限为3000条导入大量数据的情况下，请分批导入</span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">导入</el-button>
          <el-button @click="dialogDaoruVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 导入弹出层 -->
    <!-- 弹出层 -->
    <AgentAdd v-if="bolls" :msg="msg" @guan="guan"></AgentAdd>
    <el-dialog
      title="重置密码"
      :destroy-on-close="true"
      width="500px"
      :visible.sync="DialogPasswordVisible"
    >
      <span>是否重置密码，该操作不可恢复！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogPasswordVisible = false">取 消</el-button>
        <el-button type="primary" @click="Resetpassword">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 授权弹出层 -->
    <el-dialog
      title="充值授权"
      :visible.sync="dialogDistributeVisible"
      class="dialogbox"
      width="600px"
    >
      <el-form :rules="rules" ref="form" :model="form">
        <el-form-item label="授权商品:" label-width="180px">
          <el-select
            v-model="call_type_id"
            placeholder="请选择授权商品"
            size="small"
            style="width: 270px"
            @change="getMenuList"
          >
            <el-option
              v-for="item in callTypeArr"
              :key="item.call_type_id"
              :label="item.callTypeInfo.card"
              :value="item.call_type_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值对象:" label-width="180px">
          <span class="el-span">{{ scoperow.name }}</span>
        </el-form-item>
        <el-form-item label="剩余可充值数量:" label-width="180px">
          <span class="el-span" v-if="shopData.sum"
            >{{ shopData.sum - shopData.use }}个</span
          >
          <span class="el-span" v-else>0个</span>
        </el-form-item>
        <el-form-item label="APP授权数:" label-width="180px" prop="num">
          <el-input
            v-model="form.num"
            style="width: 270px"
            placeholder="请输入"
            @input="changeNumber"
            onkeyup="value=value.replace(/[^\d]/g,'').replace(/^0{1,}/g,'')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDistributeVisible = false">取 消</el-button>
        <el-button type="primary" @click="onDistribute('form')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 导入弹出层 -->
    <el-dialog
      title="导入用户"
      :visible.sync="dialogDaoruUserVisible"
      :destroy-on-close="true"
      width="666px"
    >
      <el-form :model="form4" ref="ruleForm2">
        <div class="download">
          <p>
            1.点击
            <span @click="down2">下载模板</span>
          </p>
          <p>2.将要导入的数据填写到模板文件中</p>
          <p>3.模板中表头不可更改，不可删除</p>
          <p>4.默认读取Excel表格的Sheet1的内容</p>
          <p>5.<span>确认数据已导入ICCID库中,否则将无法增加</span></p>
        </div>
        <el-upload
          class="upload-demo"
          action="#"
          multiple
          :limit="1"
          drag
          :file-list="fileList"
          :on-change="fileChange4"
          :on-remove="changeRemove4"
          :auto-upload="false"
          :on-exceed="handleExceed"
        >
          <el-button size="small" type="primary" slot="trigger">
            <i class="el-icon-download"></i> 点击上传文件
          </el-button>
        </el-upload>
        <div style="display: flex; justify-content: flex-end; margin: 14px 0">
          <el-button size="small" type="primary" @click="onSubmitUpload">
            确定
          </el-button>
          <el-button size="small" @click="cancel"> 取消 </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { postData, getData } from "@/api/index";
import AgentAdd from "./newadd";
import axios from "axios";
import Authentication from "./authentication.vue";
import { debounce } from "@/utils/tool.js";
import ExportExcel from "@/components/ExportExcel";
export default {
  data() {
    return {
      E_ids: [], //选中id
      E_condition: {}, //条件
      E_dataLength: 0, //数据长度
      E_searchArr: ["name", "mobile"], //搜索条件过滤
      E_methodname: "agent_subordinate_agents", //方法名
      zhanshi: "800px",
      select: "1",
      drawer: false,
      size: "70%",
      activeName: "first",
      pay_type: "",
      row: {},
      scoperow: {},
      a: 2,
      form: {
        user_id: "",
        num: "",
      },
      formes: {
        role: 2,
        agent_id: "",
        audit_state: 4,
        develop_type: 3,
        keywords: "",
        page: "",
        pagesize: 20,
      },
      bolls: false,
      rechargeVisible: false,
      //传到组件中的值
      msg: {},
      // 文件
      tableData: [],
      total: 0, //默认数据总数
      pagesize: 20, //每页的数据条数
      currentPage: 1, //默认开始页面
      dialogTableVisible: false,
      dialogTableVisiblekou: false,
      dialogDaoruUserVisible: false,
      name: "",
      package: {
        black_num: [],
        call_num: [],
        sms_num: [],
        video_sms_num: [],
        // crm_num: [],
        other_num: [],
      },
      packageList: [],
      count: 0,
      form2: {
        id: "",
        style: "",
        package_type: "",
        package_id: "",
        charge: "",
        remark: "",
      },
      form3: {
        file: "",
        portal_id: "",
        company_id: "",
      },
      form4: {},
      form20: {
        style: "",
        id: "",
        fee_banlance: "",
        package_type: "",
        package_id: "",
        charge: "",
        remark: "",
      },
      formLabelWidth: "100px",
      loginFormRules: {
        style: [{ required: true, message: "请选择", trigger: "change" }],
        package_type: [
          { required: true, message: "请选择产品类型", trigger: "change" },
        ],
        package_id: [
          { required: true, message: "请选择套餐", trigger: "change" },
        ],
      },
      rules: {
        user_id: [{ required: true, message: "请选择代理商", trigger: "blur" }],
        num: [
          { required: true, message: "请输入APP授权数量", trigger: "blur" },
        ],
      },
      dialogDaoruVisible: false,
      token: "",
      fileList: [],
      formData: new FormData(),
      apiHost: "",
      uploadUrl: "",
      DialogPasswordVisible: false,
      dialogDistributeVisible: false,
      shopData: [],
      selectId: 0,
      baseUrl: getVueEnv('VUE_APP_API_JUMP_URL'),
      callTypeArr: [],
      call_type_id: "",
      userCallTypeArr: [],
    };
  },
  created() {
    // this.gettingData();
    this.getMainData();
    this.getCallSeat();
    this.token = sessionStorage.getItem("token");
    this.apiHost = localStorage.getItem("service_cname");
    this.uploadUrl = `${this.apiHost}admin/UserController/ImportFileAction`;
    this.uploadUserUrl = `${this.apiHost}admin/UserController/dlsImportFileAction`;
  },
  mounted() {
    setTimeout(() => {
      var caozuo = this.$refs.caozuo.offsetHeight;
      var H = document.body.clientHeight;
      this.zhanshi = H - caozuo - 38 - 15 - 133;
    }, 100);
    const that = this;
    window.onresize = () => {
      var caozuo = that.$refs.caozuo.offsetHeight;
      var H = document.body.clientHeight;
      that.zhanshi = H - caozuo - 38 - 15 - 133;
    };
  },
  methods: {
    switchover() {
      this.formes.keywords = "";
      this.esarchang(1);
    },
    changeCalltype() {
      let params = {
        user_id: this.scoperow.id,
        call_type_id: this.call_type_id,
      };
      getData("call.CallSeatController/findOneAction", params).then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.userCallTypeArr = res.data;
      });
    },
    handleSelectionChange(val) {
      this.E_ids = [];
      val.forEach((i) => {
        this.E_ids.push(i.id);
      });
    },
    getCallSeat() {
      getData("call.CallSeatController/listAction").then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.callTypeArr = res.data;
      });
    },
    inputsearch: debounce(function(e) {
      this.esarchang(1);
    }),
    async onSubmitUpload() {
      if (this.form4.file) {
        const formData = new FormData();
        formData.append("file", this.form4.file);
        formData.append("parent_id", this.form4.parent_id);
        const res = await axios.post(this.uploadUserUrl, formData, {
          headers: {
            token: sessionStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
        });
        if (res) {
          if (res.data.code === 200) {
            this.$message.success("用户导入成功");
            setTimeout(() => {
              this.cancel();
            }, 1000);
          } else {
            if (res.data.code < -1) {
              window.sessionStorage.clear();
              this.$message({
                type: "warning",
                message: "你的token失效了,请重新登录!",
              });
              router.replace({
                path: "/", // 到登录页重新获取token
              });
            } else {
              this.$message.error(res.data.message);
            }
          }
        }
      } else {
        return this.$message.error("请选择要导入的文件");
      }
    },
    down2() {
      this.$message.success("正在下载中");
      getData("UserController/dlsDemoAction").then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg);
        window.location.href = res.data;
      });
    },
    cancel() {
      this.dialogDaoruUserVisible = false;
      this.form4 = {};
      this.esarchang();
    },
    // 数量超
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    fileChange4(file) {
      this.form4.file = file.raw;
    },
    changeRemove4() {
      this.form4.file = "";
    },
    usersDaoru(row) {
      this.dialogDaoruUserVisible = true;
      this.form4.parent_id = row.id;
    },
    onDistribute(formName) {
      this.form.user_id = this.scoperow.id;
      this.form.call_type_id = this.call_type_id;
      if (this.form.num == 0)
        return this.$message.error("充值数量必须大于等于1个");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确定充值授权, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              getData("call.CallSeatController/setAgentAction", this.form).then(
                (res) => {
                  if (res.code == 200) {
                    this.$message({
                      message: "充值成功",
                      type: "success",
                    });
                    this.dialogDistributeVisible = false;
                    this.$refs[formName].resetFields();
                    this.esarchang();
                  } else {
                    this.$message.error(res.message);
                  }
                }
              );
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            });
        } else {
          ("error submit!!");
          return false;
        }
      });
    },
    changeKokuanNumber() {
      if (this.form.num > userCallTypeArr.sum - userCallTypeArr.use) {
        this.form.num = userCallTypeArr.sum - userCallTypeArr.use;
      }
    },
    changeNumber() {
      if (this.form.num >= this.shopData.sum - this.shopData.use) {
        this.form.num = this.shopData.sum - this.shopData.use;
      }
    },
    onrecharge(row) {
      this.scoperow = row;
      this.form = {
        user_id: "",
        num: "",
      };
      this.call_type_id = "";
      this.dialogDistributeVisible = true;
    },
    onReset(row) {
      this.selectId = row.id;
      this.DialogPasswordVisible = true;
    },
    Resetpassword() {
      postData("UserController/initPasswordAction", { id: this.selectId }).then(
        (res) => {
          if (res.code !== 200) {
            this.$message.error(res.message);
            return true;
          }
          this.$message.success("重置密码成功");
          this.DialogPasswordVisible = false;
          this.esarchang();
        }
      );
    },
    daoru() {
      this.dialogDaoruVisible = true;
    },
    minRules(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入金额"));
      } else if (value < 1) {
        callback(new Error("充值金额不得小于1元 "));
      } else {
        callback();
      }
    },
    minRules2(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入个数"));
      } else if (value < 1) {
        callback(new Error("充值个数不得小于1个 "));
      } else {
        callback();
      }
    },
    // 获取支付配置
    // gettingData() {
    //   getData("business/ProjectPayConfigAction").then((res) => {
    //     if (res.code !== 200) return this.$message.error(res.msg);
    //     this.pay_type = res.data;
    //     if (this.pay_type == 0) {
    //       this.form2.style = 1;
    //       this.form20.style = 1;
    //     } else if (this.pay_type == 1) {
    //       this.form2.style = 2;
    //       this.form20.style = 2;
    //     }
    //   });
    // },
    // 下载导入模板
    down() {
      getData("UserController/demoAction").then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg);
        window.location.href = res.data;
      });
    },
    // 导入提交
    async onSubmit() {
      if (this.form3.file) {
        const formData = new FormData();
        formData.append("file", this.form3.file);
        const res = await axios.post(this.uploadUrl, formData, {
          headers: {
            token: sessionStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
        });
        if (res) {
          if (res.data.code === 200) {
            this.$message.success("导入成功");
            this.dialogDaoruVisible = false;
            this.esarchang();
          } else {
            if (res.data.code < -1) {
              window.sessionStorage.clear();
              this.$message({
                type: "warning",
                message: "你的token失效了,请重新登录!",
              });
              router.replace({
                path: "/", // 到登录页重新获取token
              });
            } else {
              this.$message.error(res.data.message);
            }
          }
        }
      } else {
        return this.$message.error("请选择要导入的文件");
      }
    },
    changeFile(file) {
      this.form3.file = file.raw;
    },
    changeRemove() {
      this.form3.file = "";
      this.form4.file = "";
    },
    setMeal(value) {
      this.form2.package_id = "";
      this.form20.package_id = "";
      this.packageList = [];
      if (value == 1) {
        this.packageList = this.package.black_num;
      } else if (value == 2) {
        this.packageList = this.package.call_num;
      } else if (value == 3) {
        this.packageList = this.package.sms_num;
      } else if (value == 4) {
        this.packageList = this.package.video_sms_num;
      } else if (value == 7) {
        this.packageList = this.package.other_num;
      }
    },
    getMenuList() {
      getData(
        "call.CallSeatController/findOneAction?call_type_id=" +
          this.call_type_id
      ).then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.shopData = res.data;
      });
    },
    // 获取余数
    SysAction(value) {
      postData("agent/SysAction", {
        admin_id: this.form2.id,
        package_type: this.form2.package_type,
        package_id: value,
      }).then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.count = res.data;
      });
    },
    SysAction2(value) {
      postData("agent/SysAction", {
        admin_id: this.form20.id,
        package_type: this.form20.package_type,
        package_id: value,
      }).then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.count = res.data;
      });
    },
    recharge(row) {
      this.form2 = row;
      this.name = row.name;
      // this.sysPackAgeList();
      this.dialogTableVisible = true;
    },
    Rechargekou(row) {
      this.scoperow = row;
      this.form = {
        user_id: "",
        num: "",
      };
      this.call_type_id = "";
      this.dialogTableVisiblekou = true;
    },
    guanbi(loginFormRef) {
      // console.log(loginFormRef);/
      this.$refs[loginFormRef].resetFields();
    },
    // 充值
    addRecharge(loginFormRef) {
      this.$refs[loginFormRef].validate((valid) => {
        if (valid) {
          this.$confirm("确定充值, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let form2 = {
                to: this.form2.id,
                type: 1,
                money: this.form2.charge,
              };
              postData("UserController/updateMoneyAction", form2).then(
                (res) => {
                  if (res.code !== 200) {
                    this.$message.error(res.message);
                    return true;
                  }
                  this.$message.success("充值成功");
                  this.esarchang();
                  this.dialogTableVisible = false;
                  this.count = 0;
                  this.$refs[loginFormRef].resetFields();
                }
              );
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            });
        } else {
          this.$message.success("验证失败");
          return false;
        }
      });
    },
    // 扣款
    addRechargekou(loginFormRef) {
      let params = {
        user_id: this.scoperow.id,
        call_type_id: this.call_type_id,
        num: -this.form.num,
      };
      this.$refs[loginFormRef].validate((valid) => {
        if (valid) {
          this.$confirm("确定扣款, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              getData("call.CallSeatController/setAgentAction", params).then(
                (res) => {
                  if (res.code !== 200) {
                    this.$message.error(res.message);
                    return true;
                  }
                  this.$message.success("扣款成功");
                  this.dialogTableVisiblekou = false;
                  this.$refs[formName].resetFields();
                  this.esarchang();
                }
              );
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
              this.form20.charge = "";
              this.form20.remark = "";
              this.form20.package_type = "";
              this.form20.package_id = "";
            });
        } else {
          this.$message.success("验证失败");
          return false;
        }
      });
    },
    // 详情
    particulars(row) {
      // this.drawer = true;
      // this.row = row;
    },
    // 关闭侧滑
    close() {
      this.drawer = false;
      this.size = "70%";
      this.a = 2;
      this.esarchang();
    },
    // 放大侧滑
    amplification(a) {
      this.a = a;
      if (a == 1) {
        this.size = "100%";
      } else {
        this.size = "70%";
      }
    },
    //搜索
    esarchang(flag) {
      if (flag) {
        this.currentPage = 1;
        this.pagesize = 20;
      }
      if (this.formes.keywords == "") return this.getMainData();
      let formes = {
        page: this.currentPage,
        pagesize: this.pagesize,
        role: 2,
      };
      if (this.select == "1") {
        formes.name = this.formes.keywords;
      }
      if (this.select == "2") {
        formes.mobile = this.formes.keywords;
      }
      if (this.select == "3") {
        formes.id = this.formes.keywords;
      }
      this.E_condition = formes;
      getData("UserController/pageAction", formes).then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.E_dataLength = res.data.total;
        this.pagesize = res.data.per_page;
      });
    },
    //刷新
    shuaxin() {
      this.currentPage = 1;
      this.pagesize = 20;
      this.formes = {
        agent_id: "",
        keywords: "",
        role: "",
        audit_state: "4",
        develop_type: "3",
      };
      this.getMainData();
      this.$message({ message: "刷新成功", type: "success" });
    },
    headerCellStyle() {
      return "text-align:center;background-color:#F2f2f2;";
    },
    cellStyle() {
      return "text-align:center;";
    },
    // 获取数据
    getMainData() {
      let params = {
        page: this.currentPage,
        role: 2,
        pagesize: this.pagesize,
      };
      this.E_condition = params;
      getData("UserController/pageAction", params).then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.E_dataLength = res.data.total;
        this.pagesize = res.data.per_page;
      });
    },
    // 新增
    dialogFormVisible() {
      this.bolls = true;
      this.msg.bool = this.bolls;
      this.msg.title = "新增";
      this.msg.bianji = {};
    },
    guan(val) {
      this.rechargeVisible = val;
      this.bolls = val;
      this.msg.bianji = {};
    },
    // 编辑
    handleEdit(row) {
      this.bolls = true;
      this.msg.bool = this.bolls;
      this.msg.title = "编辑";
      this.msg.bianji = row;
    },
    //充值
    handleRecharge(row) {
      this.rechargeVisible = true;
      this.msg.rechargeVisible = this.rechargeVisible;
      this.msg.bianji = row;
    },
    // 删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          postData("agent/agentDelAction", { id: row.id }).then((res) => {
            if (res.code !== 200) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.esarchang();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.esarchang();
    },
    // 分页
    current_change: function(currentPage) {
      this.currentPage = currentPage;
      this.esarchang();
    },
    // 跳转
    async getWebCname(row) {
      const res = await getData("UserController/agentTokenAction", {
        id: row.id,
      });
      if (res.code !== 200) return this.$message.error(res.message);
      window.open(`${this.baseUrl}?token=${res.data}&&name=${row.name}`);
      // window.open(
      //   `http://localhost:8081/#/login?token=${res.data}&&name=${row.name}`
      // );
    },
  },
  components: {
    AgentAdd,
    Authentication,
    ExportExcel,
  },
  watch: {
    $route() {
      setTimeout(() => {
        var caozuo = this.$refs.caozuo.offsetHeight;
        var H = document.body.clientHeight;
        this.zhanshi = H - caozuo - 38 - 15 - 133;
      }, 100);
      const that = this;
      window.onresize = () => {
        var caozuo = that.$refs.caozuo.offsetHeight;
        var H = document.body.clientHeight;
        that.zhanshi = H - caozuo - 38 - 15 - 133;
      };
    },
  },
};
</script>

<style lang="less">
.el-tabs--border-card {
  border: 0;
  box-shadow: none;
}
#xiashu .el-dialog__body {
  padding-top: 10px;
  min-height: 600px;
}
</style>
<style lang="less" scoped>
.Success {
  color: #67c23a;
}
.red {
  color: #f56c6c;
}
.especially /deep/.el-input__inner {
  border-radius: 5px 0 0 5px;
}
.especially2 /deep/.el-input__inner {
  border-radius: 0 5px 5px 0;
  border-left: 0;
}
.especially /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
}
.especially2 /deep/.el-input__inner:focus {
  border: 1px solid #c0c4cc;
  border-left: 0;
}
.el-container {
  display: flex;
  flex-direction: column;
}
.el-table /deep/ th {
  padding: 8px 0;
}
.zrss {
  display: flex;
  .moban {
    margin-left: 10px;
    padding: 0px 20px;
    font-size: 14px;
    height: 38px;
    margin-top: 1px;
    line-height: 36px;
  }
}
.nomargin {
  margin: 0 !important;
}
/deep/.el-drawer {
  height: 100% !important;
}
.head {
  height: 81px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 21px;
  .head-l {
    font-size: 18px;
    display: flex;
    align-items: center;
    color: #333333;
    span {
      margin-right: 10px;
      background-color: #409eff;
      color: white;
      font-size: 12px;
      padding: 5px 17px;
      display: block;
      line-height: 11px;
      border-radius: 2px;
    }
  }
  .head-r {
    button {
      background-color: #f2f4fb;
      color: #333333;
      border: none;
      border-radius: 4px;
      margin-right: 12px;
      padding: 7px 16px;
      font-size: 14px;
    }
    span {
      width: 14px;
      height: 14px;
      margin-right: 19px;
      cursor: pointer;
    }
  }
}
.main {
  display: flex;
  flex-direction: column;
  background-color: #f1f1f3;
  padding: 15px 15px;
  height: 100%;

  .detailed {
    background-color: #fff;
    display: flex;
    flex-wrap: wrap;
    padding: 10px 22px;
    div {
      width: 25%;
      color: #666666;
      font-size: 14px;
      line-height: 27px;
      span {
        margin-left: 45px;
        color: #333333;
      }
    }
  }
  .tab-control {
    flex: 1;
    background-color: #fff;
    padding: 0px 20px;
    margin-top: 15px;
    /deep/.el-tabs__nav-wrap {
      height: 50px;
      line-height: 50px;
    }
  }
  /deep/.el-tabs__nav-wrap::after {
    height: 1px !important;
  }
}
</style>
<style lang="less" src="@/assets/css/dialogbox.less" scoped></style>
<style src="@/assets/css/index.css" scoped></style>
<style scoped>
.el-form /deep/ .el-form-item__error {
  left: 0px;
}
</style>
